module.exports = __webpack_public_path__ + "img/img_chart.cb3b2f9b.jpg";